module.exports = __webpack_public_path__ + "source/img/thumb-down-fill.04dc4bf0.svg";